import React from 'react';
import PageIframe from 'App/components/PageIframe/PageIframe';
import { usePageIframeInit } from 'App/components/PageIframe/usePageIframeInit';
import './OrderPage.scss';

type Props = {
	/** Slug of the agent_page to embed (placement === 'orderModal'). */
	slug: string;
	/** The order being edited — exposed to the page via `useOrder()`. */
	orderId: number;
	/** The order's account, if any — exposed to the page via `useAccount()`. */
	clientId: number | null;
};

/**
 * Embeds a sandboxed Upsales Page (placement: 'orderModal') as a tab inside the
 * order edit modal. Passes the order id (and the order's client id) into the
 * iframe init so the page's `useOrder()` / `useAccount()` hooks resolve to the
 * order being edited (WEB-6999).
 */
export default function OrderPage({ slug, orderId, clientId }: Props) {
	const init = usePageIframeInit(clientId, orderId);

	return (
		<div className="OrderAgentPage">
			<PageIframe slug={slug} init={init} />
		</div>
	);
}
